import React, { useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import { useAddParkMutation } from 'src/api/manageParksApi'

export type IFormInput = {
  name: string
  address: string
  latitude: number
  longitude: number
  about: string
  open: string
  close: string
}

export const formSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  address: Yup.string().required('Address is required'),
  // latitude: Yup.number().required('Latitude is required').min(1,'Latitude is required'),
  // longitude: Yup.number().required('Longitude is required').min(1,'Longitude is required'),
  latitude: Yup.number().required('Latitude is required'),
  longitude: Yup.number().required('Longitude is required'),
  about: Yup.string().required('About park is required'),
  open: Yup.string().required('Open timing is required'),
  close: Yup.string().required('Close timing is required'),
})

type useAddParkProps = {
  successCallback: () => void
}
const useAddPark = ({ successCallback }: useAddParkProps) => {
  const [file, setFile] = useState<File | null>(null)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      address: '',
      about: '',
      open: '',
      close: '',
      latitude: 0,
      longitude: 0,
    },
  })
  const [addPark, { isLoading: isLoadingAddPark }] = useAddParkMutation()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)
    if (!file) {
      errorToast('Park image is required.')
      return
    }
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('address', data.address)
    formData.append('about', data.about)
    formData.append('opened_at', data.open.toString())
    formData.append('closed_at', data.close.toString())
    formData.append('latitude', data.latitude.toString())
    formData.append('longitude', data.longitude.toString())
    formData.append('picture', file)
    addPark(formData)
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Park added successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to add park.')
      })
  }

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingAddPark,
  }
}

export default useAddPark
